export function skeleton(): void {
  function onDocumentReady(): void {
    // Observer for img elements
    const imgObserver = new MutationObserver(() => {
      const allImageElements = document.querySelectorAll('img');
      allImageElements.forEach((imageElement) => {
        if (imageElement) {
          const parentElement =
            imageElement.closest('.cmp-image') ?? (imageElement.parentElement as HTMLElement);
          parentElement.classList.add('cmp-skeleton');
          const isSvg = imageElement.src.endsWith('.svg');
          if (imageElement.complete || isSvg) {
            parentElement.classList.remove('cmp-skeleton');
          } else {
            imageElement.onload = () => {
              parentElement.classList.remove('cmp-skeleton');
            };
          }
        }
      });
    });

    // Observer for background images
    const bgImageObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const targetElement = mutation.target as HTMLElement;

          // Check if the background-image style has changed
          if (targetElement.style.backgroundImage) {
            // Extract the image URL from the background-image style
            const urlMatch = targetElement.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/);
            if (urlMatch?.[1]) {
              const imgUrl = urlMatch[1];

              // Add skeleton class and hide the background image using a placeholder class
              targetElement.classList.add('cmp-skeleton');
              targetElement.classList.add('hide-background');

              const img = new Image();
              img.src = imgUrl;

              // Set up the onload handler to remove the skeleton class and show the background image
              img.onload = () => {
                targetElement.classList.remove('cmp-skeleton');
                targetElement.classList.remove('hide-background');
              };

              img.onerror = () => {
                console.error('Failed to load background image:', imgUrl);
              };
            }
          }
        }
      });
    });

    // Start observing for img elements
    imgObserver.observe(document.body, { childList: true, subtree: true });

    // Find the container elements and observe for style changes
    setTimeout(() => {
      const bgImageContainers = document.querySelectorAll('.backgroundImageContainerCarousel');
      bgImageContainers.forEach((container) => {
        // Record the current `background-image` style in case of changes
        bgImageObserver.observe(container, { attributes: true, attributeFilter: ['style'] });
      });
      const bgImageContainersIVL2 = document.querySelectorAll(
        '.backgroundImageContainerInteractiveVisualList2'
      );
      bgImageContainersIVL2.forEach((container) => {
        // Record the current `background-image` style in case of changes
        bgImageObserver.observe(container, { attributes: true, attributeFilter: ['style'] });
      });
    }, 1000); // Delay to ensure elements are in the DOM

    const numberOfResultsText = document.querySelector('#number_of_results');
    numberOfResultsText?.classList.add('cmp-skeleton--results');

    const numberOfFavoriteText = document.querySelector('#saved_cruises');
    numberOfFavoriteText?.classList.add('cmp-skeleton--results');

    const itineraryDetailsContainer = document.querySelector('.itinerary-details-container');
    itineraryDetailsContainer?.classList.add('cmp-skeleton--itinerarycard');

    const itineraryCruiseCard = document.querySelector('.itinerarycruisecard');
    if (!itineraryCruiseCard?.classList.contains('cmp-vertical-carousel')) {
      const cmpItineraryCruiseCard = document.querySelector('.cmp-itinerarycruisecard');
      cmpItineraryCruiseCard?.classList.remove('cmp-skeleton--itinerarycruisecard');
      const skeletonCards = document.querySelectorAll('.cmp-skeleton--itinerarycruisecard-item');
      skeletonCards.forEach((card) => {
        card.remove();
      });
    }

    const sortingComponent = document.querySelectorAll('.sorting');
    sortingComponent.forEach((element) => {
      element.classList.add('hidden');
    });
  }

  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

skeleton();
